import type {TextProps} from '@Components/text';

export interface WavyTextProps extends TextProps {
  containerClassName?: string;
  colorType?: ColorType;
  emojiText?: string;
}

export enum ColorType {
  DEFAULT = 'default',
  HALLOWEEN = 'halloween',
  CHRISTMAS = 'christmas',
}
